import React from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";

const container = document.getElementById("app");
const root = createRoot(container);
const useStrict = false;
const app = <App />;

const getContent = () => {
  if (useStrict) {
    return <React.StrictMode>{app}</React.StrictMode>;
  } else {
    return app;
  }
};

root.render(getContent());
